import type { DataItems, KeyDetails } from './tableTypes';

// This is used to get the column widths for tables
export default function getKeyDetails(data: DataItems): KeyDetails {
  const result: KeyDetails = {};
  Object.keys(data[0]).forEach((key) => {
    result[key] = {
      key,
      width: Math.max(
        key.length,
        data
          .map((item) => item[key].toString().length)
          .sort((a: number, b: number) => b - a)[0],
      ),
    };
  });
  return result;
}
